// Author YuJiaBei
// Date 2022-01-03 10:10:50

class EmAttachment {
constructor({
        id = null,
        fileComment = '',
        linkedTableName = '',
        linkedTableComment = '',
        linkedTableRecordId = '',
        linkedFieldName = '',
        linkedFieldComment = ''}
= {}) {
    this.id = id;
    this.fileComment = fileComment;
    this.linkedTableName = linkedTableName;
    this.linkedTableComment = linkedTableComment;
    this.linkedTableRecordId = linkedTableRecordId;
    this.linkedFieldName = linkedFieldName;
    this.linkedFieldComment = linkedFieldComment;
}
}

function newEntity() {
return new EmAttachment();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'fileMd5',
        label: 'label.em.admin.emAttachment.grid.fileMd5',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fileName',
        label: 'label.em.admin.emAttachment.grid.fileName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fileNameExt',
        label: 'label.em.admin.emAttachment.grid.fileNameExt',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fileSize',
        label: 'label.em.admin.emAttachment.grid.fileSize',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fileComment',
        label: 'label.em.admin.emAttachment.grid.fileComment',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'linkedTableName',
        label: 'label.em.admin.emAttachment.grid.linkedTableName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'linkedTableComment',
        label: 'label.em.admin.emAttachment.grid.linkedTableComment',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'linkedTableRecordId',
        label: 'label.em.admin.emAttachment.grid.linkedTableRecordId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'linkedFieldName',
        label: 'label.em.admin.emAttachment.grid.linkedFieldName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'linkedFieldComment',
        label: 'label.em.admin.emAttachment.grid.linkedFieldComment',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'downloadTimes',
        label: 'label.em.admin.emAttachment.grid.downloadTimes',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdBy',
        label: 'label.em.admin.emAttachment.grid.createdBy',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdTime',
        label: 'label.em.admin.emAttachment.grid.createdTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'updatedBy',
        label: 'label.em.admin.emAttachment.grid.updatedBy',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'updatedTime',
        label: 'label.em.admin.emAttachment.grid.updatedTime',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    fileNameFilter : '',
    fileMd5Filter : '',
    fileNameExtFilter : '',
    fileSizeGreaterThanFilter : '',
    fileSizeLessThanFilter : '',
    linkedTableNameFilter : '',
    linkedFieldNameFilter : '',
    createdTimeGreaterThanFilter : '',
    createdTimeLessThanFilter : '',
    updatedTimeGreaterThanFilter : '',
    updatedTimeLessThanFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'fileNameFilter',
        label: 'label.em.admin.emAttachment.filter.fileName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fileMd5Filter',
        label: 'label.em.admin.emAttachment.filter.fileMd5',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fileNameExtFilter',
        label: 'label.em.admin.emAttachment.filter.fileNameExt',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fileSizeGreaterThanFilter',
        label: 'label.em.admin.emAttachment.filter.fileSizeGreaterThan',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fileSizeLessThanFilter',
        label: 'label.em.admin.emAttachment.filter.fileSizeLessThan',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'linkedTableNameFilter',
        label: 'label.em.admin.emAttachment.filter.linkedTableName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'linkedFieldNameFilter',
        label: 'label.em.admin.emAttachment.filter.linkedFieldName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'createdTimeGreaterThanFilter',
        label: 'label.em.admin.emAttachment.filter.createdTimeGreaterThan',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'createdTimeLessThanFilter',
        label: 'label.em.admin.emAttachment.filter.createdTimeLessThan',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'updatedTimeGreaterThanFilter',
        label: 'label.em.admin.emAttachment.filter.updatedTimeGreaterThan',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'updatedTimeLessThanFilter',
        label: 'label.em.admin.emAttachment.filter.updatedTimeLessThan',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'fileComment',
        label: 'label.em.admin.emAttachment.entity.fileComment',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'linkedTableName',
        label: 'label.em.admin.emAttachment.entity.linkedTableName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'linkedTableComment',
        label: 'label.em.admin.emAttachment.entity.linkedTableComment',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'linkedTableRecordId',
        label: 'label.em.admin.emAttachment.entity.linkedTableRecordId',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'linkedFieldName',
        label: 'label.em.admin.emAttachment.entity.linkedFieldName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'linkedFieldComment',
        label: 'label.em.admin.emAttachment.entity.linkedFieldComment',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmAttachment, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
